import Index from "@frog/source/models/App.js"
import Director from "@frog/source/models/juice/Director.js"

import pixel from "@frog/source/views/app/stage/pixel.js"
import Keyset from "@frog/source/utility/Keyset.js"
import Geometry from "@frog/source/utility/Geometry.js"

import World from "@frog/source/models/World.js"

const RANGE_IMAGES = {
    "block": {
        // "invoke skill": require("@frog/source/images/red.range.png"),
        // "move": require("@frog/source/images/blue.range.png"),
        // "wait-for-move": require("@frog/source/images/blue.range.png"),
        // "move through": require("@frog/source/images/blue.range.png"),
        "invoke skill": require("@frog/source/images/ld47/invoke skill range.png"),
        "move": require("@frog/source/images/ld47/move range.png"),
        "wait-for-move": require("@frog/source/images/ld47/move range.png"),
        "move through": require("@frog/source/images/ld47/move range.png"),
    },
    // "east-ramp": {
    //     "invoke skill": require("@frog/source/images/red-range-east-ramp.png"),
    //     "move": require("@frog/source/images/blue-range-east-ramp.png"),
    //     "move through": require("@frog/source/images/blue-range-east-ramp.png"),
    // },
    // "south-ramp": {
    //     "invoke skill": require("@frog/source/images/red-range-south-ramp.png"),
    //     "move": require("@frog/source/images/blue-range-south-ramp.png"),
    //     "move through": require("@frog/source/images/blue-range-south-ramp.png"),
    // }
}

// This logic is very similiar to Selection.findAction, but takes
// some performance shortcuts for the rendering loop.
function findAction(actionlist, unit) {
    // if(Index.game.encounter.selection.selectedSkillKey != undefined) {
    // || unit.energy["move"] == false) {
    if(unit.energy["move"] == false
    && unit.energy["invoke skill"] == true) {
        return actionlist.find((action) => {
            return action.type == "invoke skill"
                && Geometry.equals(action.positions[1], unit.position)
        })
    } else if(unit.energy["move"] == true) {
        return actionlist.find((action) => {
            return action.type == "move"
                || action.type == "wait-for-move"
                || action.type == "move through"
        })
        // return actionlist.find((action) => action.type == "move") || actionlist[0]
    }
}

// TODO: merge this in with the range function so it's not duped
export function getActionableTileType(position, stage) {
    const unitKey = Index.game.encounter.selection.selectedUnitKey || Index.game.encounter.selection.hoveredUnitKey
    if(unitKey != undefined
    && Director.isPerforming != true) {
        const unit = stage.units[unitKey]
        if(unit.affiliation == "bad") return // FOR LUDUM DARE ??
        let actionmap = unit.actionmap
        // if(stage.nextTurn != undefined // REMOVED FOR LUDUM DARE
        // && stage.nextTurn.aiActions != undefined
        // && stage.nextTurn.aiActions[unit.key] != undefined
        // && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
        //     actionmap = stage.nextTurn.aiActions[unit.key].actionmap
        // }
        if(unit == undefined
        || actionmap == undefined) {
            return
        }
        const actionlist = actionmap[Geometry.toString(position)]
        if(actionlist == undefined) return
        const action = findAction(actionlist, unit)
        if(action == undefined) return
        const terrain = World.getTerrain(stage.world, action.position)
        if(terrain.position.z == 0) return
        return action.type
    }
}

const ROTATIONS = {}
const MAX_ROTATION = 10
for(let x = 0; x < 6; x += 1) {
    for(let y = 0; y < 6; y += 1) {
        ROTATIONS[x + "x" + y] = (Math.random() * MAX_ROTATION) - (MAX_ROTATION / 2)
    }
}

export default function ActionRangeLayer(stage) {
    // TILE RANGE
    const unitKey = Index.game.encounter.selection.selectedUnitKey || Index.game.encounter.selection.hoveredUnitKey
    if(unitKey != undefined
    && Director.isPerforming != true) {
        const unit = stage.units[unitKey]
        if(unit.affiliation == "bad") return // FOR LUDUM DARE ??
        let actionmap = unit.actionmap
        // if(stage.nextTurn != undefined // REMOVED FOR LUDUM DARE
        // && stage.nextTurn.aiActions != undefined
        // && stage.nextTurn.aiActions[unit.key] != undefined
        // && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
        //     actionmap = stage.nextTurn.aiActions[unit.key].actionmap
        // }
        if(unit != undefined
        && actionmap != undefined) {
            const views = []
            Keyset.forEach(actionmap, (actionlist, positionKey) => {
                const action = findAction(actionlist, unit)
                if(action == undefined) return
                const terrain = World.getTerrain(stage.world, action.position)
                if(terrain.position.z == 0) return
                // if(terrain != undefined
                // && terrain.shape == "ramp"
                // && RANGE_IMAGES[terrain.direction+"-"+terrain.shape] != undefined
                // && RANGE_IMAGES[terrain.direction+"-"+terrain.shape][action.type]) {
                //     views.push({
                //         "key": "unit/" + unitKey + "/range/" + positionKey, // action.key,
                //         "image": RANGE_IMAGES[terrain.direction+"-"+terrain.shape][action.type],
                //         "position": pixel("range", {
                //             "x": action.position.x,
                //             "y": action.position.y,
                //             "z": action.position.z - (terrain.position.z % 1) // NOTE HOW WE OFFSET/ANCHOR THE SLOPE SHAPES, UNLIKE THE BLOCK SHAPES
                //         }),
                //     })
                //     return
                // }
                if(RANGE_IMAGES["block"][action.type] != undefined) {
                    views.push({
                        "key": "unit/" + unitKey + "/range/" + positionKey, // action.key,
                        "image": RANGE_IMAGES["block"][action.type],
                        "position": pixel("range", {
                            "x": action.position.x,
                            "y": action.position.y,
                            "z": action.position.z
                        }),
                        // "opacity": 0.5,
                        // "rotation": ROTATIONS[action.position.x + "x" + action.position.y]
                    })
                    return
                }
            })
            return views
        }
    }
}
